import {PropsWithChildren, ReactNode, Suspense} from 'react';

export interface LoadingContainerProps extends PropsWithChildren{
  loading?: boolean;
  content?: ReactNode;
}

export const LoadingContainer = ({children, loading}: LoadingContainerProps) => {
  return (
    <Suspense fallback={<div className="flex items-center justify-center">Loading...</div>}>
      {children}
    </Suspense>
  )
}
